import { render, staticRenderFns } from "./beneficiary-bt-bank-branch.vue?vue&type=template&id=40c25174&"
import script from "./beneficiary-bt-bank-branch.vue?vue&type=script&lang=js&"
export * from "./beneficiary-bt-bank-branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports